<template>
  <v-card
    height="50"
    class="mt-1"
  >
    <v-layout class="ml-2">
      <v-flex
        md7
        lg7
        xl7
      >
        <v-card-actions
          class="pt-0 my-0 px-0 mb-3"
        >
          <v-list-item class="py-0 my-0 px-0">
            <v-list-item-content class="py-0 my-0">
              <v-list-item-title class="font-size-11 cmr-label-text">
                Booking ID
              </v-list-item-title>
              <v-list-item-subtitle class="font-size-11 cmr-value-text">
                {{ bookingForm.booking.id }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="py-0 my-0 px-0">
            <v-list-item-content>
              <v-list-item-title class="font-size-11 cmr-label-text">
                Status
              </v-list-item-title>
              <v-list-item-subtitle class="font-size-11 cmr-value-text">
                <v-chip
                  x-small
                  :color="getChipColor(bookingForm.booking.state)"
                  :class="getChipTextColor(bookingForm.booking.state)"
                  class="px-0"
                >
                  <span class="pa-2">
                    {{ bookingForm != null && bookingForm.booking ? bookingForm.booking.state : "" }}
                  </span>
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="py-0 my-0 px-0">
            <v-list-item-content>
              <v-list-item-title class="font-size-11 cmr-label-text">
                Customer
              </v-list-item-title>
              <v-list-item-subtitle class="font-size-11 cmr-value-text">
                {{ bookingForm != null && bookingForm.user != null ? bookingForm.user.name : "" }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="py-0 my-0 px-0">
            <v-list-item-content>
              <v-list-item-title class="font-size-11 cmr-label-text">
                <a
                  href="#"
                  @click.stop="goToUser(bookingForm.user.id)"
                >
                  <v-btn
                    depressed
                    class="text-capitalize mr-1"
                    small
                  >
                    View Account
                  </v-btn>
                </a>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="bookingForm && updateMode == true"
            class="py-0 my-0 px-0"
          >
            <v-list-item-content>
              <v-list-item-title class="font-size-11 ">
                <BookingActions
                  :booking-form="bookingForm"
                  :update-mode="updateMode"
                  :app-bar="true"
                  :show-message-supplier-dialog="showMessageSupplierDialog"
                  @supplierConfirmationDialogClose="showMessageSupplierDialog = false"
                />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="bookingForm && updateMode == true"
            class="py-0 my-0 px-0"
          >
            <v-list-item-content>
              <v-list-item-title class="font-size-11">
                <v-btn
                  depressed
                  small
                  class="text-capitalize"
                  @click="showMessageSupplierDialog = true "
                >
                  Message Supplier
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="bookingForm"
            class="py-0 my-0 px-0"
          >
            <v-list-item-content>
              <v-list-item-title class="font-size-11">
                <v-btn
                  color="primary"
                  small
                  class="text-capitalize ml-2"
                  @click="supportTicketDialog = true "
                >
                  <v-icon small class="mr-1">mdi-headset</v-icon>
                  Create Support Ticket
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <div class="text-center">
      <v-dialog
        v-model="supportTicketDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="grey lighten-2">
            Create Support Ticket
            <v-spacer></v-spacer>
            <v-icon small @click="supportTicketDialog = false">mdi-close</v-icon>
          </v-card-title>
        
          <v-card-text>
            <BookingSupportTicketForm :booking="bookingForm.booking" @close="supportTicketDialog = false"></BookingSupportTicketForm>
          </v-card-text>
          
        </v-card>
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import BookingActions from "@/components/widget/input/MessageCustomerMenu.vue";
import BookingSupportTicketForm from '@/components/support/BookingSupportTicketForm'
export default {
  name: "BookingAppBar",
  components: {
    BookingSupportTicketForm,
    BookingActions
  },
  props: {
    bookingForm: {
      default: null,
      type: Object
    }
  },
  data () {
    return {
      supportTicketDialog: false,
      showMessageSupplierDialog: false,
      updateMode: true,
    }
  },
  methods: {
    getChipColor(state) {
      if (state == 'cancelled') {
        return 'red lighten-4'
      }
      if (state == 'completed') {
        return 'green lighten-4'
      }
      if (state == 'booked') {
        return 'blue lighten-4'
      }
      return null
    },
    getChipTextColor(state) {
      if (state == 'cancelled') {
        return 'red--text'
      }
      if (state == 'completed') {
        return 'green--text'
      }
      if (state == 'booked') {
        return 'blue--text'
      }
      return null
    },
    goToUser: function (id) {
      window.open(`/customer/view/${id}`, "_blank");
    },

  }
}
</script>

<style scoped>

</style>